define('viewmodels/modals/dialogs/HelpDialog',[
    'knockout',
    'underscore'
], function (ko, _) {

    var HelpDialog = function (dialog, publishMenuClosed, helpViewModel, title) {
        var self = this;

        self.help = helpViewModel;

        self.dialog = dialog;
        self.title = title;

        self.dialog.showHelpDialog = function (obj, activationData) {
            if (!this.getContext('help').hasActiveDialog()) {
                this.show(obj, activationData, 'help')
            } else {
                this.getContext('help').showHost(self);
            }
            self.help.tryOpen();
        };

    };

    HelpDialog.prototype.minimize = function () {
        this.dialog.getContext('help').hideHost(this);
        this.help.open(false);
    };

    HelpDialog.prototype.close = function () {
        this.dialog.getContext('help').hideHost(this);
    };

    return HelpDialog;
});

